let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d5w2d")).then(() => parcelRequire('bOUpD'));